import { cva } from 'class-variance-authority';

/**
 * Button styling variants. Kept out of button.tsx so that file exports components only, which is what
 * Vite's fast refresh requires.
 */
export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-brand-surface text-on-brand hover:bg-brand-surface-hover',
        secondary: 'bg-surface-strong text-ink hover:bg-surface-stronger',
        ghost: 'text-brand-700 hover:bg-brand-50',
      },
      size: {
        sm: 'h-8 px-3',
        md: 'h-10 px-4',
        lg: 'h-11 px-6',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);
